import React from "react";
import ResourcePanel from "../ResourcePanel/ResourcePanel";
import HubspotFormV2 from "../../components/HubspotFormV2/HubspotFormV2";
import Modal from "react-responsive-modal";
const styles = require("./AdditionalResources.module.scss");
const modalStyles = require("../../styles/formModal.module.scss");

const AdditionalResources = (props) => {
  const { items, heading } = props;
  const [openModal, setOpenModal] = React.useState(false);
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  const panelTotal = items.length;

  const ctaClick = (item) => {
    setSelectedIndex(item);
    setOpenModal(true);
  };

  const renderForm = () => {
    const form = items[selectedIndex].form;
    return (
      <HubspotFormV2
        formId={form.hubspotCode}
        recaptureId={`"resource-"${selectedIndex}`}
        title={form.heading}
        alwaysConsent={true}
        isPopup={true}
        titleDescription={form.mainCopy}
        confirmationMessage={form.confirmationCopy}
        submitButton={{
          bkgColor: "blackOnLight",
        }}
        selectStyles={{
          option: (provided) => ({
            ...provided,
            color: "black",
          }),
          placeholder: (provided) => ({
            ...provided,
            color: "#2d2d2d",
            opacity: 0.4,
          }),
          singleValue: (provided) => ({
            ...provided,
            color: "#2d2d2d",
          }),
          valueContainer: (provided) => ({
            ...provided,
            color: "#2d2d2d",
            height: "50px",
          }),
          control: (provided, state) => ({
            ...provided,
            backgroundColor: "transparent",
            border: "1px solid #2d2d2d",
            width: "100%",
            color: "white",
            borderRadius: "0",
            marginBottom: "10px",
          }),
        }}
      />
    );
  };

  const panel = (title, copy, image, iconCta, index) => {
    return (
      <ResourcePanel
        title={title}
        copy={copy}
        image={image}
        button={iconCta}
        buttonColor="blackOnLight"
        buttonClick={() => ctaClick(index) || null}
      />
    );
  };

  return (
    <>
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        center
        classNames={{
          overlay: "customOverlay",
          modal: modalStyles.formModal,
          closeIcon: modalStyles.formCloseIcon,
          closeButton: modalStyles.formCloseButton,
        }}
      >
        {renderForm()}
      </Modal>
      <h2 className={styles.sectionHeader}>{heading}</h2>
      <div className={styles.multiPanel}>
        {items.map(({ title, copy, image, iconCta }, index) => {
          return (
            <>
              {panelTotal === 5 && (
                <>
                  {index <= 1 ? (
                    <div
                      className={`${styles.panel} ${styles.topRow} ${styles.largePanel} ${styles.md6} col-12 col-md-6`}
                    >
                      {panel(title, copy, image, iconCta, index)}
                    </div>
                  ) : (
                    <div
                      className={`${styles.panel} ${styles.fivePanelMd4} col-12 col-md-4`}
                    >
                      {panel(title, copy, image, iconCta, index)}
                    </div>
                  )}
                </>
              )}
              {(panelTotal === 3 || panelTotal >= 6) && (
                <>
                  <div
                    className={`${styles.panel} ${
                      styles.ThreePanelMd4
                    } col-12 col-md-4 ${
                      index <= 2 && panelTotal === 6 ? styles.topRow : ""
                    }`}
                  >
                    {panel(title, copy, image, iconCta, index)}
                  </div>
                </>
              )}
              {(panelTotal === 1 || panelTotal === 2 || panelTotal === 4) && (
                <>
                  <div
                    className={`${styles.panel} ${styles.md6} ${
                      styles.largePanel
                    } col-12 col-md-6 ${
                      index <= 1 && panelTotal === 4 ? styles.topRow : ""
                    }`}
                  >
                    {panel(title, copy, image, iconCta, index)}
                  </div>
                </>
              )}
            </>
          );
        })}
      </div>
    </>
  );
};

export default AdditionalResources;
